/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import getSearchEvents from '../../../../../api/graphql/queries/searchEvents';
import Modal from '../../../../Modal/Modal';


const EventsTicketsList = ({
  activeLanguage, updateComponentInParentState, languages, index, reusableComponent, slider, event, deleteItemHandler,
}) => {
  const styles = {
    position: 'absolute',
    width: '98%',
    height: '48px',
    marginLeft: '2%',
    overflow: 'visible',
    pointerEvents: 'auto',
    transformOrigin: '50% 50% 0px',
    bordeRadius: '5px',
    color: 'white',
    lineHeight: '66px',
    paddingLeft: '32px',
    fontSize: '14.5px',
    background: '#c8c8c8',
    textTransform: 'uppercase',
    letterSpacing: '2px',
  };

  // const [index, setIndex] = useState();
  const [showForm, setShowForm] = useState(false);
  const [state, setState] = useState(event);
  const [selectedEvents, setSelectedEvents] = useState([]);
  const [eventsSlugs, setEventsSlugs] = useState([]);

  useEffect(() => {
    console.log('event', event);
    setState(event);
    setSelectedEvents(event.content[0].eventSlugnames);
  }, [event]);

  const searchEventHandler = (e) => {
    const { value } = e.target;
    if (value === '') return setEventsSlugs([]);
    getSearchEvents(value).then((res) => {
      if (res === null) return setEventsSlugs([]);
      setEventsSlugs(res);
    });
  };

  const selectEventHandler = (slug) => {
    setSelectedEvents(slug);
    let newEvents = [];

    const eventIndex = selectedEvents.findIndex(ev => ev === slug);

    if (eventIndex === -1) {
      setSelectedEvents([...selectedEvents, slug]);
      newEvents = [...selectedEvents, slug];
    } else {
      const newSelected = selectedEvents;
      newSelected.splice(eventIndex, 1);
      setSelectedEvents(newSelected);
      newEvents = newSelected;
    }

    // update component State
    let newContent = [];

    const isEventTours = event && event.hasOwnProperty('button') && event.button.category.toLowerCase() === 'tours' && event.button.text.en.toLowerCase() === 'tours';

    if (isEventTours) {
      newContent = [
        {
          type: 'CarouselTickets',
          eventSlugnames: newEvents,
          isGrid: true,
          isConcert: true,
        },
      ];
    } else {
      newContent = [
        {
          type: 'CarouselTickets',
          eventSlugnames: newEvents,
        },
      ];
    }

    const newState = {
      ...state,
      content: newContent,
    };

    setState(newState);

    // upadte component in its parent
    updateComponentInParentState(newState, index);
  };

  const inputTextMultilangHandler = (e) => {
    const { value, lang } = e.target;
    const newState = {
      ...state,
      text: {
        ...state.text,
        [lang]: value,
      },
    };

    setState(newState);
    updateComponentInParentState(newState, index);
  };

  const inputButtonTextMultilangHandler = (e) => {
    const { value, lang } = e.target;
    const newState = {
      ...state,
      button: {
        ...state.button,
        text: {
          ...state.button.text,
          [lang]: value,
        },

      },
    };

    setState(newState);
    updateComponentInParentState(newState, index);
  };

  const inputCategoryHandler = (e) => {
    const { value } = e.target;
    const newState = {
      ...state,
      button: {
        ...state.button,
        category: value,
      },
    };

    setState(newState);
    updateComponentInParentState(newState, index);
  };

  const handleClick = () => {
    setShowForm(!showForm);
  };

  return (
    <>
      {showForm
        && (
          <Modal title="Add new" handleClick={handleClick} type="display" positionMiddle size={`w-5/6 ${eventsSlugs.length > 0 && selectedEvents.length > 0 && 'h-112'}`}>
            <div className={`bg-greyWithinForm mt-6 mr-4 ml-2 mb-2 rounded-lg ${eventsSlugs.length > 0 && selectedEvents.length === 0 && 'h-72'}`}>
              <div>
                <p className="text-xs uppercase pl-1 text-white font-americaMonoRegular mb-0 pl-6 mt-1 pt-2">Search Event</p>
                <input className={`rounded-full pr-4 pl-8 py-1 h-8 outline-none mx-4 font-americaMonoRegular text-sm w-7/8 mt-1 ${eventsSlugs.length === 0 && 'mb-2'}`} type="text" onChange={searchEventHandler} />
                <span className="font-icon icon-search z-5 text-black absolute mt-3 ml-13 text-sm left-0" />
              </div>
              {eventsSlugs.length > 0 && (
                <div className={`z-top ml-4 mr-2 absolute mr-2 ${selectedEvents && 'absolute min-w-92'}`}>
                  <p className={`font-americaMonoBold text-xs uppercase bg-greyFilter pl-6 mt-3.5 mb-0 mr-2 pb-1 pt-1 w-full py-2 rounded-t-lg ${selectedEvents ? 'py-2' : 'pb-1'}`}>Available events</p>
                  <div className="first-child overflow-auto bg-greyFilterItems rounded-b-lg pb-2 mr-4 max-h-150 w-full">
                    {eventsSlugs.map(eventSlug => (
                      <div onClick={() => selectEventHandler(eventSlug.eventSlugName)} key={eventSlug.eventSlugName}>
                        <p className="text-black cursor font-americaMonoRegular outline-none w-full pl-6 mb-0 mt-0">{eventSlug.eventSlugName}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {(selectedEvents && selectedEvents.length > 0) && (
                <div className={`${eventsSlugs.length > 0 ? 'mt-56' : 'mt-0'} mx-4 pb-4`}>
                  <p className="font-americaMonoBold text-xs uppercase bg-greyFilter pl-6 mb-0 mr-2 pb-1 mt-0 w-full py-2 rounded-t-lg py-2">Selected event</p>
                  <div className="overflow-auto bg-greyFilterItems rounded-b-lg max-h-150 w-full">
                    {selectedEvents.map(selectedEvent => (
                      <div>
                        <p className="text-black cursor font-americaMonoRegular outline-none w-full pl-6 mb-0 mt-0">
                          {selectedEvent}
                          <span className="font-icon icon-close-btn1 absolute text-black text-12 font-thin right-0 relative pl-1" onClick={() => selectEventHandler(selectedEvent)} key={selectedEvent} />
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </Modal>
        )
      }
      <div className="bg-greyFilter">
        <div className="w-full p-4 pt-1 pl-6 ml-1 pr-2 flex flex-col" style={styles}>
          <div className="flex flex-row items-start">
            {languages.map(lang => (
              <div key={lang} className={`w-7/8 h-fit-content ${activeLanguage.toLowerCase() === lang.toLowerCase() ? 'block' : 'hidden'} `}>
                <label className="flex font-americaMonoRegular text-xs uppercase text-black font-bold h-10 items-center" htmlFor="title">
                  title
                  <input className="withinSlider text-sm font-americaMonoRegular bg-white outline-none w-full rounded-full h-8 px-4" onChange={inputTextMultilangHandler} name="text" lang={lang.toLowerCase()} type="text" value={state.text[lang.toLowerCase()]} />
                </label>
              </div>
            ))}
            <div className="w-7/8 block h-fit-content flex">
              <label className="flex font-americaMonoRegular text-xs uppercase text-black font-bold h-10 items-center ml-4" htmlFor="tag">
                category
                <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full text-sm px-2 h-8" onChange={inputCategoryHandler} name="category" type="text" value={state.button.category} />

              </label>
              {languages.map(lang => (
                <div key={lang} className={`w-7/8 h-fit-content ${activeLanguage.toLowerCase() === lang.toLowerCase() ? 'block' : 'hidden'} `}>

                  <label className="flex font-americaMonoRegular text-xs uppercase text-black font-bold h-10 items-center" htmlFor="title">
                    text
                    <input className="withinSlider text-sm font-americaMonoRegular bg-white outline-none w-full rounded-full h-8 px-4" onChange={inputButtonTextMultilangHandler} name="button-text" lang={lang.toLowerCase()} type="text" value={state.button.text[lang.toLowerCase()]} />
                  </label>
                </div>
              ))}
            </div>
            <div className="relative w-1/5 h-fit-content flex flew-row">
              <button type="button" className="font-americaMonoBold text-xs pl-10 pr-6 py-1 h-7 mx-6 mt-2px rounded-full uppercase bg-black text-white flex flex-row items-center" onClick={handleClick}>
                Select event
                <span className="font-icon icon-add-button text-base font-bold pl-2" />
              </button>
            </div>
            <div className="absolute right-0 top-0 h-10 flex items-end mt-1" onClick={() => deleteItemHandler(index)}>
              <span className="font-icon icon-close-solid text-16 text-white" />
            </div>
          </div>
          <div />
        </div>
      </div>
    </>
  );
};

EventsTicketsList.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  reusableComponent: PropTypes.shape(),
  event: PropTypes.shape(),
  slider: PropTypes.bool,
};
EventsTicketsList.defaultProps = {
  reusableComponent: null,
  slider: false,
  event: null,
};

export default EventsTicketsList;
